import { IZReport } from "@prostocheck/shared";

import { parseDocumentXml, readText } from "../document-xml";
import { Z_REPORT_SECTIONS } from "./z-report-xml.constants";
import { IParseZReportParams } from "./z-report-xml.models";
import { readSectionTotals } from "./z-report-xml.utils";

/**
 * Maps a `<ZREP>` document onto `IZReport`. The XML records what the shift
 * turned over, not when it ran — the shift number and its open/close times come
 * from the `Shifts` command and are passed in.
 */
export const parseZReport = ({
  data,
  fiscalNumber,
  shiftNumber,
  openedAt,
  closedAt,
}: IParseZReportParams): IZReport => {
  const document = parseDocumentXml(data);
  const head = document.querySelector(Z_REPORT_SECTIONS.head) ?? document;

  const sales = readSectionTotals(
    document.querySelector(Z_REPORT_SECTIONS.sales),
  );
  const returns = readSectionTotals(
    document.querySelector(Z_REPORT_SECTIONS.returns),
  );

  return {
    fiscalNumber: readText(head, "ORDERTAXNUM") || fiscalNumber,
    cashRegisterFn: readText(head, "CASHREGISTERNUM"),
    shiftNumber,
    openedAt,
    closedAt,
    salesTotal: sales.sum,
    returnsTotal: returns.sum,
    salesCount: sales.ordersCount,
    returnsCount: returns.ordersCount,
    payments: sales.payments,
    vat: sales.vat,
  };
};
